import {CREATE_PROJECT_STARTED} from "../../reducers/createProjectReducer";


export const createProjectStarted = () =>{
    return {
        type: CREATE_PROJECT_STARTED,
        payload: {}
    }
}